module.exports = __webpack_public_path__ + "img/paved_unstabilized.8fa51da3.png";